import React from 'react';
export var DiciottoAppLogo = function DiciottoAppLogo() {
  return React.createElement("svg", {
    width: "40",
    height: "26",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("defs", null, React.createElement("path", {
    id: "b",
    d: "M.004 0h15.373v21.774H.004z"
  }), React.createElement("path", {
    id: "d",
    d: "M5.728 18.454H15.94v4.454H5.73z"
  }), React.createElement("filter", {
    id: "a"
  }, React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  }))), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "#2A609E",
    d: "M0 0h40v26H0z"
  }), React.createElement("g", {
    filter: "url(#a)"
  }, React.createElement("g", {
    transform: "translate(12 2.108)"
  }, React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#b"
  })), React.createElement("path", {
    d: "M5.458.555C8.391-.57 11.55.08 13.824 1.931c2.692 2.194.761 3.897-1.058 4.254-.343.067-1.238.16-2.019-.387-.78-.547-2.273-.998-3.268-1.64-.995-.642-1.332-1.162-1.497-1.59-.165-.43-.768-.001-.802.681-.033.682.463 1.614 1.113 1.975.65.36 1.216.912.833 1.196-.382.285-1.006.662-1.422.861-.415.2-1 .522-.866 1.18.134.657.345.95.68 1-.268.279-.148 1.257.576 1.451-.228.482.359 1.241 1.124 1.184.03.54.364 1.1 1.2.918.835-.183 2.721-.786 3.748-1.518 2.711-1.933 4.071.67 2.624 2.406-.85 1.02-1.993 1.81-3.318 2.318A8.39 8.39 0 015.458.555M1.988 21.774h-.887v-2.839H0v-.669c.619.013 1.188-.2 1.282-.869h.706v4.377M3.902 19.16c.363 0 .657-.2.657-.575 0-.225-.107-.607-.657-.607-.356 0-.67.22-.67.607 0 .382.314.575.67.575zm.006 2.033c.425 0 .75-.3.75-.738 0-.42-.337-.7-.75-.7-.431 0-.775.243-.775.693 0 .45.35.745.775.745zm-.006-3.884c1.088 0 1.463.75 1.463 1.176 0 .431-.225.782-.638.92v.012c.52.118.82.519.82 1.069 0 .92-.826 1.376-1.639 1.376-.844 0-1.663-.426-1.663-1.37 0-.556.313-.95.825-1.075v-.013c-.425-.119-.644-.469-.644-.9 0-.788.763-1.195 1.476-1.195z",
    fill: "#2A609E",
    mask: "url(#c)"
  }), React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#d"
  })), React.createElement("path", {
    d: "M7.88 20.192c-.151.131-.464.138-.739.188-.275.056-.525.15-.525.475 0 .331.256.413.544.413.694 0 .72-.55.72-.745v-.33zm-2.052-.657c.05-.831.794-1.081 1.52-1.081.644 0 1.419.144 1.419.919v1.682c0 .294.031.588.113.72h-.9a1.32 1.32 0 01-.063-.314c-.282.294-.694.4-1.088.4-.613 0-1.1-.306-1.1-.969 0-.731.55-.906 1.1-.981.544-.082 1.05-.063 1.05-.425 0-.382-.263-.438-.575-.438-.338 0-.557.137-.588.487h-.888zM11.543 20.167c0-.513-.206-1.044-.775-1.044-.581 0-.769.519-.769 1.044s.2 1.026.775 1.026c.582 0 .77-.5.77-1.026zm-2.4-1.626h.843v.413H10c.213-.344.563-.5.963-.5 1.013 0 1.47.819 1.47 1.738 0 .863-.476 1.67-1.42 1.67-.388 0-.757-.17-.97-.488h-.012v1.538h-.888v-4.37zM15.052 20.167c0-.513-.207-1.044-.776-1.044-.581 0-.769.519-.769 1.044s.2 1.026.775 1.026c.582 0 .77-.5.77-1.026zm-2.402-1.626h.845v.413h.012c.213-.344.563-.5.963-.5 1.013 0 1.47.819 1.47 1.738 0 .863-.476 1.67-1.42 1.67-.388 0-.757-.17-.97-.488h-.012v1.538h-.888v-4.37z",
    fill: "#2A609E",
    mask: "url(#e)"
  })))));
};